<template>
  <b-card>
    <h3>Request</h3>

    <table>
      <tbody>
        <tr
          v-for="(el, idx) in tripDetailsRequest"
          :key="idx"
        >
          <td> {{ el.name }} </td>
          <td
            class="d-flex justify-content-end"
            :style="{
              'color': el.colored ? '#28c76f' : ''
            }"
          >
            {{ el.value }}
          </td>
        </tr>
      </tbody>
    </table>
  </b-card>
</template>

<script>
import { BCard } from 'bootstrap-vue'
import { inject, computed } from '@vue/composition-api'

export default {
  components: { BCard },
  setup() {
    const trip = inject('trip')
    const tripDetailsRequest = computed(() => {
      let arr = []
      if (trip.value) {
        const { metadata } = trip.value
        const {
          service,
        } = metadata
        // First try to get from distance_matrix_data rows structure
        let durationAndDistance = metadata?.distance_matrix_data?.[0]?.rows?.[0]?.elements?.[0]
        
        // If rows doesn't exist, check routes structure
        if (!durationAndDistance && metadata?.distance_matrix_data?.[0]?.routes?.[0]?.localizedValues) {
          const routeData = metadata.distance_matrix_data[0].routes[0].localizedValues
          durationAndDistance = {
            distance: { text: routeData.distance?.text },
            duration: { text: routeData.duration?.text }
          }
        }
        arr = [
          { value: service?.class, name: 'Class Name' },
          { value: service?.name, name: 'Service Name' },
          { value: metadata?.distance_traveled_km ? `${metadata.distance_traveled_km} KM` : '_', name: 'dispatch distance to rider' },
          { value: durationAndDistance && durationAndDistance?.duration?.text ? `${durationAndDistance.duration?.text}` : '_', name: 'Time To user' },
          { value: durationAndDistance && durationAndDistance?.distance?.text ? `${durationAndDistance.distance?.text}` : '_', name: 'Distance To User' },
          { value: metadata?.distance?.mobile?.distance ? (+metadata?.distance?.mobile?.distance).toFixed(2) : '_', name: 'Mobile Distance' },
          { value: metadata?.distance?.mobile?.oldDistance ? (+metadata?.distance?.mobile?.oldDistance).toFixed(2) : '_', name: 'Old Mobile Distance' },
          { value: metadata?.distance?.mobile?.newDistanceCalculation ? (+metadata?.distance?.mobile?.newDistanceCalculation).toFixed(2) : '_', name: 'New Mobile Distance' },
          { value: metadata?.distance?.mobile?.percentage ? `${(+metadata?.distance?.mobile?.percentage).toFixed(2)}` : '_', name: 'Mobile Percentage' },
          { value: metadata?.distance?.server ? `${(+metadata?.distance?.server?.distance).toFixed(2)} KM` : '_', name: 'Server Distance' },
          { value: metadata?.distance?.server ? `${(+metadata?.distance?.server?.percentage).toFixed(2)}` : '_', name: 'Server Percentage' },
          { value: metadata?.distance?.google?.distance ? `${(+metadata?.distance?.google?.distance).toFixed(2)} KM` : '_', name: 'Google Distance ' },
          { value: metadata?.distance?.chosenDistance ? `${metadata?.distance?.chosenDistance}` : '_', name: 'Chosen Distance ', colored: true },
        ]
      }
      return arr
    })
    return {
      tripDetailsRequest,
    }
  },
}
</script>

<style src="./table-style.css" scoped>

</style>
